<template>
<div id="app">
        <!-- <el-button type="primary"  size="mini" class="back" @click="goBack()">返回</el-button> -->
        <div class="ibox-title">
            <h5>详情</h5>
        </div> 
        <div id="report_main"></div>
</div>

</template>
<script>

import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件

export default {

  name: 'app',
  data () {
      return {
            // 对象属性
        }
    },
  methods: {
      goBack () {
          this.$emit('close', false)
        }
    },
  created () {
      this.reportID = this.$route.params.id
        api.post(config.host + 'report/getRecReportByID.do', {'reportID': this.reportID}).then((data) => {
          var filter = data.body.reportReceiveBos.contentUrl.split(',')
                var title = data.body.reportReceiveBos.contents.split('；')
                var html = ''
                $.each(filter, function (i) {
                  html += '<p class="baobiaotit">' + title[i] + '</p><iframe class="baobiao" width=100% height=600px frameborder=0 scrolling=auto src="' + filter[i] + '"></iframe>'
                })
                $('#report_main').html(html)
        })
    },
  watch: {
      $route: {
          handler: function () {
              this.reportID = this.$route.params.id
                api.post(config.host + 'report/getRecReportByID.do', {'reportID': this.reportID}).then((data) => {
                  var filter = data.body.reportReceiveBos.contentUrl.split(',')
                    var title = data.body.reportReceiveBos.contents.split('；')
                    var html = ''
                    $.each(filter, function (i) {
                      html += '<p class="baobiaotit">' + title[i] + '</p><iframe class="baobiao" width=100% height=600px frameborder=0 scrolling=auto src="' + filter[i] + '"></iframe>'
                    })
                    $('#report_main').html(html)
                })
            },
          deep: true
        }
    }

}
</script>
<style scoped>
    #report_main{
        min-height:600px;
    }
    .ibox-title{
        border-bottom: 1px solid #ddd;
        margin-bottom: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/uploadDetail.vue?2989ed09